import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table';
import { formatDate2 } from 'shared/utility';
import { Tooltip } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import Button from '../../../components/CustomButtons/Button';
import NotificationAsk from '../../../components/Notification/NotificationAsk';
import { ERTLStatusDescriptions } from './ERTLModel';
import { useViewFilters } from "../../../components/ViewFiltersModal/useViewFilters";

const VIEW_FILTERS_MODULE = "ertl";

const subFilterMap = {
    draft: [0],
    pending_owner: [1],
    pending_docusign: [2],
    pending_final: [3],
    approved: [4],
    declined: [5],
    modified: [6],
    pending_level1: [7],
    rejected_l1: [8],
    rejected_final: [9]
};

const ERTLList = (props) => {
    const { ertlList, setERTLData, setTab, tab, subFilter } = props;
    const [askDelete, setAskDelete] = useState(null);

    const isAllTab = tab === 'All';
    const subFilterValue = subFilter || 'all';

    const filteredList = ertlList ? ertlList.filter(l => {
        if (!isAllTab || subFilterValue === 'all') return true;
        const allowedStatuses = subFilterMap[subFilterValue];
        if (!allowedStatuses) return true;
        return allowedStatuses.indexOf(l.status) !== -1;
    }) : [];

    const data = filteredList.map((l, key) => {
        const d = l.data;
        const address = `${d.property_address1} ${d.property_address1} ${d.property_city}
                            ${d.property_state} ${d.property_zipcode}`;
        const statusDesc = ERTLStatusDescriptions && ERTLStatusDescriptions[l.status]
            ? ERTLStatusDescriptions[l.status]
            : (l.status === 0 ? 'Draft' : `Status ${l.status}`);
        const canEditOrDelete = !isAllTab || l.status === 0;
        const switchToRowTab = () => {
            if (!isAllTab || !props.setTab) return;
            if (l.status === 0) props.setTab('Drafts');
            else if (l.status === 1) props.setTab('Pending To Review');
            else props.setTab('Pending');
        };
        return ({
            id: l.id,
            address,
            created_date: formatDate2(l.created_date),
            modified_date: formatDate2(l.modified_date),
            status: statusDesc,
            template: l.template_id ? 'Revised Template' : 'Original Template',
            ertlData: l,
            _statusNum: l.status,
            actions: <div>
                        {canEditOrDelete && <Tooltip
                                title="Edit"
                                placement="top"
                            ><Button
                                justIcon
                                round
                                simple
                                onClick={() => {
                                    switchToRowTab();
                                    setERTLData(l)
                                    if (l.template_id) props.getTemplate(l.template_id)
                                }}
                                color="primary"
                                className="mr-20"
                            >
                                <Edit />
                            </Button>
                          </Tooltip>
                        }
                        {canEditOrDelete && <Tooltip
                                title="Delete"
                                placement="top"
                            ><Button
                                justIcon
                                round
                                simple
                                onClick={() => {
                                    switchToRowTab();
                                    setAskDelete(l.id);
                                }}
                                color="primary"
                                className="mr-20"
                            >
                                <i className="fas fa-trash font-22"></i>
                            </Button>
                          </Tooltip>
                        }
                        </div>
        })
    });

    const columns = [
        {
            Header: "#",
            accessor: "id" 
        },
        {
            Header: "Address",
            accessor: "address",
            minWidth: 200 
        },
        {
            Header: "Date Created",
            accessor: "created_date"
        },
        {
            Header: "Date Modified",
            accessor: "modified_date"
        },
        {
            Header: "Status",
            accessor: "status"
        },
        {
            Header: "Template Used",
            accessor: "template"
        },
        {
            Header: "Actions",
            accessor: "actions"
        }
    ]

    const effectiveTab = isAllTab ? subFilterValue : tab;
    const { filteredColumns, viewFiltersButton } = useViewFilters(VIEW_FILTERS_MODULE, columns, effectiveTab);

    return (
        <div className="table-adjust23">
            <div style={{ marginBottom: 10 }}>{viewFiltersButton}</div>

            <ReactTable
                filterable
                className='-striped'
                showPaginationTop
                showPaginationBottom
                resizable={true}
                defaultPageSize={10}
                pageSizeOptions={[10, 20, 30]}
                data={data}
                columns={filteredColumns}
                getTdProps={(state, rowInfo, column) => ({
                    onClick: (e, handleOriginal) => {
                        if (isAllTab && rowInfo && rowInfo.original && column.id !== 'actions' && props.setTab) {
                            const s = rowInfo.original._statusNum;
                            if (s === 0) props.setTab('Drafts');
                            else if (s === 1) props.setTab('Pending To Review');
                            else props.setTab('Pending');
                        }
                        if (handleOriginal) handleOriginal();
                    },
                    style: isAllTab && column.id !== 'actions' ? { cursor: 'pointer' } : {}
                })}
            />

            {askDelete !== null && <NotificationAsk 
                open={true}
                close={() => {
                    setAskDelete(null);
                }}
                success={() => {
                    props.deleteErtlEntry(askDelete);
                    setAskDelete(null);
                }}
                title="Are you sure?"
                message="Do you want to delete this ERTL?"
                success_button_text="Yes, Delete"
            />}
        </div>
    )
}

export default ERTLList;